import Config from 'react-native-config';

import dayjs from 'dayjs';
import noop from 'lodash/noop';

import { VisitSummary, FilterItem } from 'store/visitSummary/types';
import { JsonObj } from '@mhp/general-interface';

export const getEVisitFeatureRestriction = (visit: VisitSummary, callback: Function) => {
  if (Config.EVISITS === 'enabled') {
    if (visit?.status === 'in-progress') {
      return noop();
    }
  }
  return callback(visit);
};

export const getLastThreeYears = () => {
  const currentYear = +dayjs().format('YYYY');
  const lastYears: FilterItem[] = [
    { value: String(currentYear), label: String(currentYear), checked: false },
    { value: String(currentYear - 1), label: String(currentYear - 1), checked: false },
    { value: String(currentYear - 2), label: String(currentYear - 2), checked: false }
  ];
  return lastYears;
};

const getUniqueMappedElements = (
  summariesData: VisitSummary[],
  objectProperty: string,
  valueProperty: string,
  labelProperty: string
) => {
  const hashMap: JsonObj = {};
  return summariesData.reduce((filtered: FilterItem[], element: VisitSummary) => {
    const id = element[objectProperty]?.[valueProperty];
    const label = element[objectProperty]?.[labelProperty];

    if (!hashMap[id] && id && label) {
      hashMap[id] = id;
      const newElement: FilterItem = {
        value: id,
        label,
        checked: false
      };
      filtered.push(newElement);
    }
    return filtered;
  }, [] as FilterItem[]);
};

export const getProviders = (data: VisitSummary[]) =>
  getUniqueMappedElements(data, 'primaryProvider', 'providerId', 'providerName');

export const getLocations = (data: VisitSummary[]) =>
  getUniqueMappedElements(data, 'locationObject', 'locationId', 'locationName');
